import { Link } from 'react-router-dom';
import Layout from '../../../components/layout/Layout';
import Breadcrumb from '../../../components/layout/Breadcrumb';

// ===== 関連サイト / Queen's Butler（クイーンズバトラー） — 執事ベル詳細ページと同一構造（新デザイン憲章・inline化） =====
// 外部公式URL https://queensbutler.jp/ は変更禁止。当ルートは pagesWithOwnFaq 登録済み＝FAQ自前描画。
// 画像は Queen's Butler 公式サイトの実写（site-queensbutler/public/img/scenes）から複製。料金は記載しない。
// 実見済み原本（alt は実画像の内容に基づく）:
// image-match-evidence: D:/AI/site-queensbutler/public/img/scenes/s19_studio_portrait-600.webp
// image-match-evidence: D:/AI/site-queensbutler/public/img/scenes/s17_footman_tea_practice-600.webp

const points = [
  { title: '執事サロン（女性限定）', en: 'Butler Salon', desc: '執事が仕える館で、女性のお客様だけがくつろげるサロン。お茶のもてなしから館での過ごし方まで、執事がお迎えします。', img: '/images/related/queens-butler/qb-salon-tea.webp', alt: 'シャンデリアのあるダイニングで執事が女性のお客様にお茶を給仕する様子' },
  { title: 'スタジオ・レンタルスペース', en: 'Studio & Space', desc: '調度の整った館の各室を、撮影スタジオやレンタルスペースとしてご利用いただけます。', img: '/images/related/queens-butler/qb-studio-portrait.webp', alt: 'シャンデリアの下のダイニングテーブルで撮影する女性の様子' },
  { title: '執事見習い体験', en: 'Apprentice Experience', desc: '執事の装いに身を包み、お茶の給仕や所作を学ぶ執事見習いの体験。執事文化を自ら体験できる機会です。', img: '/images/related/queens-butler/qb-footman-practice.webp', alt: '執事の指導のもと白手袋でティーポットを扱う見習いの様子' },
];

const faqs = [
  {
    q: 'Queen\'s Butler（クイーンズバトラー）とは何ですか？',
    a: 'Queen\'s Butler は、一般社団法人全日本執事協会が運営する、女性のための執事サロンです。東京都江東区青海2-7-4 の館で、執事サロン（女性限定）、スタジオ・レンタルスペース、執事見習い体験、オンラインショップを提供しています。',
  },
  {
    q: 'どのようなサービスがありますか？',
    a: '女性限定の執事サロンのほか、館の各室を使ったスタジオ・レンタルスペース、執事の装いと所作を学ぶ執事見習い体験、執事の装いをテーマにした受注生産品を扱うオンラインショップがあります。',
  },
  {
    q: '全日本執事協会との関係は？',
    a: 'Queen\'s Butler は当協会が運営する執事サロンです。協会が育成する執事が館でお客様をお迎えし、執事文化を体験として届ける場のひとつとなっています。ご予約・お問い合わせは公式サイト queensbutler.jp が窓口となります。',
  },
];

const otherRelated = [
  { name: '全日本執事協会 THE BUTLER', role: '執事サービス', to: '/related/the-butler' },
  { name: '執事ベル', role: '情報発信ブランド', to: '/related/butler-bell' },
  { name: '日本執事アカデミー', role: '教育・養成機関', to: '/related/butler-academy' },
];

const breadcrumbs = [
  { label: 'ホーム', href: '/' },
  { label: '関連サイト', href: '/related' },
  { label: 'Queen\'s Butler' },
];

const BTN08_ON_NAVY = "relative inline-flex items-center justify-center bg-[#a38e65] text-white font-semibold border border-[#1a2942] px-[42px] py-[16px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#1a2942] hover:text-[#f8f6f0] hover:border-[#a38e65] cursor-pointer whitespace-nowrap before:content-[''] before:absolute before:inset-1 before:border before:border-[#1a2942]/40 before:pointer-events-none before:transition-colors before:duration-300 hover:before:border-[#a38e65]/50";

function NavyBand({ no, ja, en }: { no: string; ja: string; en: string }) {
  return (
    <div className="bg-[#1a2942] border-y border-[#a38e65]/25">
      <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 py-5 sm:py-[26px] flex items-center gap-4 sm:gap-6">
        <img src="/images/brand/jba-logo.png" alt="" aria-hidden="true" className="h-8 w-8 sm:h-9 sm:w-9 object-contain shrink-0 opacity-90" />
        <span className="font-['Playfair_Display',serif] text-[#d7b779] text-xl sm:text-[26px] tracking-[0.1em] shrink-0 leading-none">{no}</span>
        <h2 className="jba-display font-medium text-[#f8f6f0] text-lg sm:text-2xl lg:text-[26px] tracking-[0.08em] leading-tight">{ja}</h2>
        <span className="hidden md:block ml-auto font-['Playfair_Display',serif] italic text-[#a38e65] text-base lg:text-[19px] tracking-[0.12em]">{en}</span>
      </div>
    </div>
  );
}

export default function RelatedQueensButlerPage() {
  return (
    <Layout>
      {/* ===== ヒーロー ===== */}
      <section className="relative bg-[#1a2942] overflow-hidden min-h-[460px] lg:min-h-[520px] flex items-center">
        <img src="/images/related/queens-butler/qb-building-night.webp" alt="夜のQueen's Butlerの館の外観" className="absolute inset-0 w-full h-full object-cover object-center" />
        <div className="absolute inset-0 bg-[linear-gradient(90deg,rgba(16,20,26,0.92)_0%,rgba(16,20,26,0.7)_50%,rgba(16,20,26,0.4)_100%)]"></div>
        <div className="relative z-10 w-full max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10 pt-32 pb-14 lg:pt-36 lg:pb-20">
          <div className="max-w-[680px]">
            <span className="block font-['Playfair_Display',serif] uppercase tracking-[0.32em] text-xs sm:text-[13px] text-[#d7b779] mb-4">Queen's Butler</span>
            <div className="w-12 h-px bg-[#a38e65] mb-6"></div>
            <h1 className="jba-display font-normal text-white text-[clamp(26px,3.2vw,42px)] leading-[1.42] tracking-[0.04em] mb-6">
              女性のための、執事サロン
            </h1>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-white/90 leading-[1.95]">
              一般社団法人全日本執事協会が運営する、女性のための執事サロン。東京・青海の館で、執事がお客様をお迎えします。
            </p>
          </div>
        </div>
      </section>
      {/* パンくず: ビルボード直後に配置（Yuichi 2026-07-17 指摘②）。共通Breadcrumbのヘッダー逃げpaddingを子セレクタで通常paddingへ上書き */}
      <div className="bg-white [&>div]:!pt-6">
        <Breadcrumb items={breadcrumbs} />
      </div>

      {/* ===== I. Queen's Butler とは — リード3段落＋画像 ===== */}
      <NavyBand no="I" ja="Queen's Butler とは" en="About" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 gap-10 lg:gap-16 items-center">
            <div className="order-2 lg:order-1 text-left">
              <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl lg:text-[30px] leading-[1.5] tracking-[0.02em] mb-5">
                執事が仕える館で、<span className="text-[#a38e65]">女性のための時間を</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                Queen's Butler（クイーンズバトラー）は、一般社団法人全日本執事協会が運営する、女性のための執事サロンです。東京都江東区青海2-7-4 の館を舞台に、執事がお客様をお迎えします。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95] mb-4">
                館では、女性限定の執事サロンのほか、調度の整った各室を使ったスタジオ・レンタルスペース、執事の装いと所作を学ぶ執事見習い体験を提供しています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#333] leading-[1.95]">
                あわせて、執事の装いをテーマにした受注生産品を扱うオンラインショップも運営しています。
              </p>
            </div>
            <div className="order-1 lg:order-2">
              <img src="/images/related/queens-butler/qb-door-welcome.webp" alt="館の扉でお客様をお迎えする執事" className="w-full h-[300px] sm:h-[400px] md:h-[480px] object-cover border border-[#a38e65]/30" />
            </div>
          </div>
        </div>
      </section>

      {/* ===== II. Queen's Butler のサービス — 白カード（各ポイントに画像）===== */}
      <NavyBand no="II" ja="Queen's Butler のサービス" en="Highlights" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid md:grid-cols-3 gap-8 lg:gap-10">
            {points.map((p) => (
              <article key={p.title} className="flex flex-col bg-white border border-[#e2ddd2] group hover:border-[#a38e65]/70 transition-colors duration-300">
                <div className="relative h-52 overflow-hidden">
                  <img src={p.img} alt={p.alt} className="absolute inset-0 w-full h-full object-cover object-top" />
                </div>
                <div className="p-7 flex flex-col flex-1 text-left">
                  <span className="block font-['Playfair_Display',serif] italic text-[#8f7a56] text-[13px] tracking-[0.06em] mb-1.5">{p.en}</span>
                  <h4 className="jba-display font-medium text-[#1a2942] text-xl mb-3 leading-[1.4]">{p.title}</h4>
                  <p className="font-['Noto_Serif_JP',serif] text-sm text-[#4a4638] leading-[1.9]">{p.desc}</p>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>

      {/* ===== III. 協会とのつながり — 紺パネル＋画像 ===== */}
      <NavyBand no="III" ja="協会とのつながり" en="Relationship" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="grid lg:grid-cols-2 items-stretch border border-[#e2ddd2] overflow-hidden">
            <div className="relative min-h-[300px] lg:min-h-[400px] bg-black order-1">
              <img src="/images/related/queens-butler/qb-drive-door-open.webp" alt="車の扉を開けてお客様をお迎えする執事" className="absolute inset-0 w-full h-full object-cover object-top" />
            </div>
            <div className="order-2 bg-[#1a2942] flex flex-col justify-center px-8 sm:px-12 lg:px-14 py-12 lg:py-16 text-left">
              <span className="block font-['Playfair_Display',serif] italic text-[#a38e65] text-sm tracking-[0.06em] mb-4">Connection with the Association</span>
              <h3 className="jba-display font-medium text-[#f8f6f0] text-2xl sm:text-3xl leading-[1.5] tracking-[0.02em] mb-6">
                協会が運営する、<span className="text-[#d7b779]">執事文化を体験する場</span>
              </h3>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95] mb-4">
                Queen's Butler は、一般社団法人全日本執事協会が運営する執事サロンです。協会が育成する執事が館でお客様をお迎えし、執事文化を体験として届ける場のひとつとなっています。
              </p>
              <p className="font-['Noto_Serif_JP',serif] text-base text-[#e7e2d8] leading-[1.95]">
                執事見習い体験で執事の装いと所作に触れたのち、体系立てて学びたい方には、当協会の教育・養成機関である日本執事アカデミーがその受け皿となります。
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== IV. 公式サイトのご案内 — 外部CTA ===== */}
      <NavyBand no="IV" ja="公式サイトのご案内" en="Official Site" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="bg-[#f8f6f0] border border-[#a38e65]/30 p-8 sm:p-10 md:p-14 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-[#1a2942] text-2xl sm:text-3xl leading-[1.5] mb-4">Queen's Butler 公式サイト</h3>
            <p className="font-['Noto_Serif_JP',serif] text-base sm:text-lg text-[#4a4638] leading-[1.95] max-w-2xl mx-auto mb-8">
              執事サロンのご予約、スタジオ・レンタルスペース、執事見習い体験、オンラインショップの詳細は、公式サイトをご覧ください。
            </p>
            <a href="https://queensbutler.jp/" target="_blank" rel="noopener noreferrer" className="relative inline-flex items-center justify-center gap-2 bg-[#1a2942] text-[#f8f6f0] border border-[#a38e65] px-[46px] py-[18px] text-sm tracking-[0.2em] font-['Noto_Serif_JP',serif] transition-colors duration-300 hover:bg-[#a38e65] hover:text-[#1a2942] hover:border-[#1a2942] cursor-pointer whitespace-nowrap">
              Queen's Butler 公式サイトを見る <i className="ri-external-link-line"></i>
            </a>
          </div>
        </div>
      </section>

      {/* ===== V. よくあるご質問（自前描画）===== */}
      <NavyBand no="V" ja="よくあるご質問" en="FAQ" />
      <section className="py-12 sm:py-16 bg-white">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <div className="max-w-4xl mx-auto border-t border-[#e2ddd2]">
            {faqs.map((f) => (
              <div key={f.q} className="border-b border-[#e2ddd2] py-6">
                <h3 className="jba-display font-medium text-[#1a2942] text-lg sm:text-xl leading-[1.5] mb-3 flex items-start gap-3">
                  <span className="font-['Playfair_Display',serif] text-[#a38e65] text-xl leading-none pt-0.5">Q.</span><span>{f.q}</span>
                </h3>
                <p className="font-['Noto_Serif_JP',serif] text-sm sm:text-base text-[#4a4638] leading-[1.95] pl-8">{f.a}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* ===== ほかの関連サイト＋CTA ===== */}
      <section className="py-12 sm:py-16 bg-[#f8f6f0]">
        <div className="max-w-[1680px] mx-auto px-4 sm:px-6 lg:px-10">
          <h3 className="jba-display font-medium text-[#1a2942] text-xl sm:text-2xl mb-8 text-center">ほかの関連サイト</h3>
          <div className="grid md:grid-cols-3 gap-6 lg:gap-8 max-w-5xl mx-auto mb-12">
            {otherRelated.map((it) => (
              <Link key={it.to} to={it.to} className="group flex items-center justify-between bg-white border border-[#e2ddd2] hover:border-[#a38e65]/70 transition-colors duration-300 p-7 text-left">
                <div>
                  <span className="block font-['Noto_Serif_JP',serif] text-xs text-[#8f7a56] tracking-[0.06em] mb-1.5">{it.role}</span>
                  <span className="jba-display font-medium text-[#1a2942] text-lg group-hover:text-[#8f7a56] transition-colors">{it.name}</span>
                </div>
                <span className="text-[#a38e65] text-lg group-hover:translate-x-1 transition-transform">→</span>
              </Link>
            ))}
          </div>
          <div className="bg-[#1a2942] border border-[#a38e65]/45 p-8 sm:p-10 text-center max-w-4xl mx-auto">
            <h3 className="jba-display font-medium text-xl sm:text-2xl text-[#f8f6f0] mb-6">執事の学びや資格に関心をお持ちの方へ</h3>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 justify-center">
              <Link to="/qualifications" className={BTN08_ON_NAVY}>執事資格制度を見る</Link>
              <Link to="/contact" className={BTN08_ON_NAVY}>お問い合わせ</Link>
            </div>
          </div>
        </div>
      </section>
    </Layout>
  );
}
